module.exports = __webpack_public_path__ + "static/img/head_manager_default.ee226a49.png";